/**
 * Copyright 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const MAX_TAG_KEY_LENGTH = 512;
